import React from "react";
import PrivacyPolicyContainer from "../containers/PrivacyPolicyContainer";

export default function PrivacyPolicy() {
  return <PrivacyPolicyContainer />;
}
